<template>
  <span class="change-rule">
    <a-popover
      v-if="!isFree && amount !== ''"
      trigger="click"
      overlayClassName="l8-order-popover order-remark-popover"
      placement="bottom"
    >
      <template slot="content">
        <div class="remark-popover-content">
          <RemarkTable
            :rule="remark"
            style="min-width: 480px"
          ></RemarkTable>
          <refund-rules-detail :ifInternational="ifInternational"></refund-rules-detail>
          <!-- <div class="remark-notice">
            <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
            <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
          </div>
          <div class="remark-warn" v-if="cmsData.refundChangeRuleTips" v-html="cmsData.refundChangeRuleTips"></div> -->
        </div>
      </template>
      <template slot="title">
        <span>退改签规则</span>
      </template>
      <span class="base-value">退改{{ amount }}元起</span>
    </a-popover>
    <span v-if="isFree">
      退改免费
    </span>
  </span>
</template>

<script>
import { find } from 'lodash'
import RemarkTable from '@/components/passenger-seg-list/module/remark-table.vue'
import getAppInfo from '@/utils/from'

const passengerTypeMap = {
  'ADT': 'ADULT',
  'CHD': 'CHILD',
  'INF': 'INFANT',
  'MWD': 'MWD',
  'PWD': 'PWD'
}
const freeTypes = ['INF', 'MWD', 'PWD']

export default {
  props: {
    type: String,
    rules: Array,
    isJJC: Boolean,
    cmsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      amount: '',
      remark: {},
      isFree: false,
      hotline: getAppInfo()?.hotline
    }
  },
  mounted () {
    this.parse()
  },
  methods: {
    parse () {
      const { type, rules, isJJC } = this

      if (isJJC) {
        this.isFree = true
        return
      }

      const idx = freeTypes.indexOf(type)

      if (idx > -1) {
        this.isFree = true
        return
      }

      const passengerType = passengerTypeMap[type]
      const rule = find(rules, { passengerType })

      if (rule) {
        this.amount = rule.refundChangeAmount
        this.remark = rule
      }
    }
  },
  components: {
    RemarkTable
  }
}
</script>
